var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"organizationsReportingChart"},[(_vm.chartConfig)?_c('vue-apex-charts',{attrs:{"type":"line","height":"100%","options":_vm.chartConfig.options,"series":_vm.chartConfig.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }